import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import ArrowrightIcon from 'icons/Arrowright.icon';
import useNdaStatus from 'hooks/useNdaStatus';
import { Lead } from 'models/Lead';
import { isNdaSent } from 'utils';
import TransWithNda from 'components/TransWithNda';
import { SHORT_MAX_CHARS } from 'components/TransWithNda/TransWithNda.component';

import './ResendNda.styles.scss';

type ResendNdaProps = {
  className?: string;
  lead: Lead;
};

const ResendNda: React.FC<ResendNdaProps> = (props) => {
  const { className, lead } = props;

  const classes = classNames('resend-nda', className);

  const {
    _id: leadId,
    envelopeTemplateId,
    envelopeId,
    signingStatus,
    envelopeTemplateName,
  } = lead;

  const { isLoading, resendNda } = useNdaStatus(leadId, envelopeId);

  if (!envelopeTemplateId || !isNdaSent(signingStatus)) return null;

  return (
    <Button
      className={classes}
      variant="outline"
      iconPosition="right"
      disabled={isLoading}
      icon={ArrowrightIcon}
      onClick={() => resendNda()}
    >
      <TransWithNda
        i18nKey="resendNDA"
        maxChars={SHORT_MAX_CHARS}
        envelopeTemplateName={envelopeTemplateName}
      />
    </Button>
  );
};

export default ResendNda;
